import { Countdown } from "../components/Countdown";

function App() {
  return (
    <>
    <Countdown />
    </>
  );
}

export default App;
